import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetEditor';
import { EquipmentLabel, IEquipmentLabelProps } from '../../../Equipment/EquipmentLabel';

export interface IWorksheetEquipmentLabelProps extends IEquipmentLabelProps {
  value?: any;
  createWorksheetSelector?: any;
}

// Component mapping worksheet editor state to a standard EquipmentLabel component
let WorksheetEquipmentLabel: React.FC<IWorksheetEquipmentLabelProps> = ({
  value,
  createWorksheetSelector = undefined,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const worksheetId = useSelector((s) => s.worksheetEditor.worksheetId);
  const importAction = (importModel: any) => dispatch(actions.import({ worksheetId, importModel }));
  const statusDate = useSelector(createWorksheetSelector('header.TestedDate', false));
  const importing = useSelector((s) => s.worksheetEditor.status.importing);
  const props = {
    importAction,
    statusDate,
    worksheetId,
    value,
    status: value?.Status,
    importing,
    ...otherProps,
  };
  return <EquipmentLabel {...props} />;
};

WorksheetEquipmentLabel = withInjectedProps(WorksheetEquipmentLabel);

export { WorksheetEquipmentLabel };
